module.exports = __webpack_public_path__ + "static/media/ring-circle.2889fb0e.png";